<template>
    <h1 >ERROR 404 - NO ENCONTRADO</h1>
</template>
<script>
export default {
  name: "ErrorCom"
};
</script>